import React, { useState } from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox,
  Box,
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
  AddCircle,
  MoreVert,
  Edit,
  Delete,
  RemoveCircle,
} from "@mui/icons-material";
import {
  get_best_seller_list,
  get_upload_file,
  add_title,
  edit_title,
  delete_title,
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-simple-toasts";

export default function Title() {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const [sort, setSort] = React.useState(0);

  const handleChangeSort = (event) => {
    setSort(event.target.value);
  };

  const [searchKey, setSearchKey] = React.useState("");
  const handleSearch = (event) => {
    setSearchKey(event.target.value);
  };

  const [loading, setLoading] = useState(false);
  const [totalList, setTotalList] = React.useState(1);
  const [pageNum, setPageNum] = React.useState(0);

  const [listData, setlistData] = React.useState([]);

  const [openAdd, setOpenAdd] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [selectedTitle, setSelectedTitle] = React.useState(null);
  const [addData, setAddData] = React.useState({
    title: "",
  });

  const getData = () => {
    setLoading(true);
    get_best_seller_list().then((json) => {
      setLoading(false);
      setlistData(json.data);
      //   setTotalList(json.total)
    });
  };

  React.useEffect(() => {
    getData();
  }, [pageNum, sort]);

  const handleChangePage = (e, ispage) => {
    setPageNum(ispage);
    // getData();
  };

  const [disabled, setDisabled] = React.useState(false);

  const handleCaptureSingle = async (e, index) => {
    setDisabled(true);
    var formData = new FormData();
    // var token = window.localStorage.getItem("token");
    // formData.append("token", token);
    formData.append("image", e.target.files[0]);
    // setisLoading(true);
    var res = await get_upload_file(formData);

    // console.log(res);
    if (res.data.status) {
      setDisabled(false);
      setAddData({
        ...addData,
        image: res.data.data,
      });
    } else {
      setDisabled(false);
      toast(res.data.message);
    }
  };

  const handleOpenAdd = (e) => {
    setOpenAdd(true);
    setAddData({
      title: "",
    });
  };
  const handleCloseAdd = (value) => {
    setOpenAdd(false);
  };

  const handleChangeAdd = (e) => {
    setAddData({
      ...addData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddTitle = () => {
    if (addData.title.length == 0) {
      toast("Please enter title");
      return;
    }

    setDisabled(true);

    let postparam = {
      ...addData,
    };

    console.log(postparam);

    add_title(postparam).then((json) => {
      if (json.status) {
        setDisabled(false);
        toast("Title Added");
        handleCloseAdd();
        getData();
        setAddData({
          title: "",
        });
      } else {
        setDisabled(false);
        toast(json.message);
      }
    });
  };

  const handleOpenEdit = (e) => {
    setOpenEdit(true);
    setAddData({
      title: e.title,
    });
  };
  const handleCloseEdit = (value) => {
    setOpenEdit(false);
  };

  const handleEditTitle = () => {
    if (addData.title.length == 0) {
      toast("Please enter title");
      return;
    }

    setDisabled(true);
    edit_title(addData).then((json) => {
      if (json.status) {
        setDisabled(false);
        toast("Title Edited");
        handleCloseEdit();
        getData();
        setAddData({
          title: "",
        });
      } else {
        setDisabled(false);
        toast(json.message);
      }
    });
  };

  const handleOpenDelete = (e) => {
    setOpenDelete(true);
    setSelectedTitle(e);
  };
  const handleCloseDelete = (value) => {
    setOpenDelete(false);
  };
  const handleDeleteTitle = () => {
    setLoading(true);
    delete_title({ product_title_id: selectedTitle }).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("Title Deleted");
        handleCloseDelete();
        getData();
      } else {
        setLoading(false);
        toast(json.message);
      }
    });
  };

  return (
    <React.Fragment>
      {/* {loading ? (
        <div style={{ margin: "auto" }}>
          <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
        </div>
      ) : (
        
      )} */}
      <Navbar2
          children={
            <Section pd="2rem">
              <div>
                <div className={classes.theFlexHeader}>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Our Best Seller
                  </Paragraph>

                  <div
                    className={classes.theFlexBtn}
                    style={{ marginBottom: "0" }}
                  >
                    <a
                      className={classes.theCustomActionBtn_}
                      onClick={() => handleOpenAdd()}
                    >
                      <AddCircle sx={{ color: "#1A5386" }} />
                      <Paragraph color="#1A5386" margin="0 0 0 .4rem">
                        Add Slider
                      </Paragraph>
                    </a>
                  </div>
                </div>
                <div
                  style={{
                    borderBottom: "2px solid #707070",
                    padding: ".2rem 0",
                  }}
                />
                <br />

                <div className={classes.theFlexAction}></div>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={12}>
                    <Card className={classes.theCard}>
                      <TableContainer>
                        <Table>
                          <TableHead style={{ backgroundColor: "#1A5386" }}>
                            <TableRow>
                              <TableCell
                                style={{ borderRadius: "10px 0 0 10px" }}
                                className={classes.theHeadTitle}
                              >
                                Title
                              </TableCell>

                              <TableCell
                                align="center"
                                style={{ borderRadius: "0 10px 10px 0" }}
                                className={classes.theHeadTitle}
                              >
                                <MoreVert sx={{ color: "#fff" }} />
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {listData != null &&
                              listData.map((item, index) => {
                                // if (searchKey != '') {
                                //   if (
                                //     item.postcode.indexOf(
                                //       searchKey.toUpperCase()
                                //     ) <= -1
                                //   ) {
                                //     return
                                //   }
                                // }
                                return (
                                  <TableRow>
                                    <a style={{ display: "contents" }}>
                                      <TableCell
                                        style={{
                                          background:
                                            index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        {item.title}
                                      </TableCell>

                                      <TableCell
                                        align="center"
                                        style={{
                                          background:
                                            index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          width: "10%",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        <Button
                                          onClick={() =>
                                            navigate(
                                              "/sliderdetail/" + item.product_title_id
                                            )
                                          }
                                          label="View"
                                          color="#fff"
                                          bg="#1A5386"
                                          size="12px"
                                          pd="10px"
                                          br="5px"
                                          style={{ marginBottom: "10px" }}
                                        />
                                        <Button
                                          onClick={() =>
                                            handleOpenDelete(item.product_title_id)
                                          }
                                          label="Delete"
                                          color="#1A5386"
                                          bg="#fff"
                                          box="1px solid #1A5386"
                                          size="12px"
                                          pd="10px"
                                          br="5px"
                                        />
                                      </TableCell>
                                    </a>
                                  </TableRow>
                                );
                              })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Card>
                    <br />
                    <br />
                  </Grid>
                </Grid>
                <br />
                <br />
              </div>

              <Dialog
                onClose={handleCloseAdd}
                open={openAdd}
                fullWidth="true"
                maxWidth="sm"
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Add Slider
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <FormInput
                    label="Title*"
                    value={addData.title}
                    textLabelColor="#000"
                    placeholder="Title"
                    name="title"
                    border="1px solid #c5c5c5"
                    onChange={handleChangeAdd}
                  />

                  <br />
                  <Box>
                    {!disabled ? (
                      <Button
                        onClick={() => handleAddTitle()}
                        label="Submit"
                        color="#fff"
                        bg="#1A5386"
                        size="18px"
                        pd="10px"
                        br="5px"
                        style={{ marginBottom: "10px" }}
                      />
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: "35px",
                        }}
                      >
                        <Loader
                          type="snipper-default"
                          bgColor={"#878787"}
                          size={30}
                        />
                      </div>
                    )}
                  </Box>
                </DialogContent>
              </Dialog>

              <Dialog
                onClose={handleCloseEdit}
                open={openEdit}
                fullWidth="true"
                maxWidth="sm"
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Edit Title
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <FormInput
                    label="Title*"
                    value={addData.title}
                    textLabelColor="#000"
                    placeholder="Title"
                    name="title"
                    border="1px solid #c5c5c5"
                    onChange={handleChangeAdd}
                  />

                  <br />

                  <Box>
                    {!disabled ? (
                      <Button
                        onClick={() => handleEditTitle()}
                        label="Save"
                        color="#fff"
                        bg="#1A5386"
                        size="18px"
                        pd="10px"
                        br="5px"
                        style={{ marginBottom: "10px" }}
                      />
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: "35px",
                        }}
                      >
                        <Loader
                          type="snipper-default"
                          bgColor={"#878787"}
                          size={30}
                        />
                      </div>
                    )}
                  </Box>
                </DialogContent>
              </Dialog>

              <Dialog
                onClose={handleCloseDelete}
                open={openDelete}
                fullWidth="true"
                maxWidth="sm"
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Delete Title
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <Paragraph
                    color="#000"
                    bold="600"
                    size="16px"
                    margin="0 0 1rem"
                  >
                    Are you sure to delete this Title?
                  </Paragraph>
                  <Button
                    onClick={() => handleDeleteTitle()}
                    label="Delete"
                    color="#fff"
                    bg="#1A5386"
                    size="18px"
                    pd="10px"
                    br="5px"
                    style={{ marginBottom: "10px" }}
                  />
                </DialogContent>
              </Dialog>
            </Section>
          }
        />
    </React.Fragment>
  );
}
